import { skipToken } from '@reduxjs/toolkit/query/react'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

/**
 * Подписка на запрос + результат из кэша: то, что `useQuerySubscription` и
 * `endpoint.select(args)` делают в binding-ах, но одной функцией.
 * `args === null` — запрос не нужен (skip). Аргументы обязаны быть стабильными
 * (useMemo у вызывающего): они же — ключ кэша.
 *
 * Состояние приложения пакет не называет: тип `S` выводится из `endpoint.select`
 * (структурная форма `{ [reducerPath]: … }`), а реальный state приложения шире и ей подходит.
 */
interface QueryEndpoint<A, R, S> {
  useQuerySubscription: (arg: A | typeof skipToken) => unknown
  select: (arg: A | typeof skipToken) => (state: S) => R
}

export function useQueryResult<A, R, S>(endpoint: QueryEndpoint<A, R, S>, args: A | null): R {
  const arg = args ?? skipToken
  endpoint.useQuerySubscription(arg)
  const select = useMemo(() => endpoint.select(arg), [endpoint, arg])
  return useSelector<S, R>(select)
}
